import React from "react";
import { useNavigate } from "react-router-dom";
import { CardMedia, Input, TextField, Button, MenuItem, Select, SelectChangeEvent, InputAdornment } from "@mui/material";
import { useState, ChangeEvent } from "react";
import CloseIcon from '@mui/icons-material/Close';
import "react-phone-input-2/lib/bootstrap.css";
import AddIcon from '@mui/icons-material/Add';

const AddSubscription = () => {

  const navigate = useNavigate();

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  const [selectField1, setSelectField1] = React.useState('default');
  const handleChange1 = (event: SelectChangeEvent) => {
    setSelectField1(event.target.value as string);
  };

  const [chips, setChips] = useState<string[]>([]);
  const [inputValue, setInputValue] = useState("");
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" && inputValue.trim() !== "") {
      event.preventDefault();
      if (!chips.includes(inputValue.trim())) {
        setChips((prev) => [...prev, inputValue.trim()]);
      }
      setInputValue("");
    }
  };
  const handleDelete = (chipToDelete: string) => {
    setChips((prev) => prev.filter((chip) => chip !== chipToDelete));
  };
  const handleAddChip = () => {
    if (inputValue.trim() !== "" && !chips.includes(inputValue.trim())) {
      setChips((prev) => [...prev, inputValue.trim()]);
      setInputValue("");
    }
  };

  return (
    <>
      <div className="main_title">
        <h1>Add Subscription</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>
          {' '} - <button onClick={() => navigate("/manage-subscriptions")}>Subscription Plans Management</button>
          {' '} - Add Subscription
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">
            <div className="control_group w_100">
              <label htmlFor="icon-button-file">Upload Image</label>
              {image ? (
                <div className="upload_image no_radius">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia component="img" image={image} alt="photo" />
                    </figure>
                    <CloseIcon
                      onClick={() => {
                        setImage("");
                        setFileName("");
                      }}
                    />
                  </div>
                </div>
              ) : (
                <label className="upload_image no_radius" htmlFor="icon-button-file">
                  <Input
                    sx={{ display: "none" }}
                    id="icon-button-file"
                    type="file"
                    inputProps={{
                      accept: "image/png,image/jpeg",
                    }}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      const files = (event.target as HTMLInputElement).files;
                      if (files && files[0].type.includes("image")) {
                        setFileName(files[0].name);
                        setImage(URL.createObjectURL(files[0]));
                      } else {
                        setAlertType(0);
                        setShowAlert(true);
                        setAlertMessage("This field only accepts images.");
                      }
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img src="/static/images/placeholder.png" alt="icon" />
                      <span className="upload_img_icon">
                        <img src="/static/images/edit2_icon.svg" alt="icon" />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>

            <div className="control_group w_33">
              <label htmlFor="name">Name</label>
              <TextField id="name" placeholder="Enter Name" hiddenLabel fullWidth />
            </div>

            <div className="control_group w_33">
              <label htmlFor="price">Price</label>
              <TextField id="price" placeholder="Enter Price" hiddenLabel fullWidth />
            </div>

            <div className="control_group w_33">
              <label htmlFor="type">Type</label>
              <Select
                id="type"
                fullWidth
                value={selectField1}
                onChange={handleChange1}
              >
                <MenuItem disabled value="default">
                  Select Type
                </MenuItem>
                <MenuItem value={10}>Monthly</MenuItem>
                <MenuItem value={20}>Yearly</MenuItem>
              </Select>
            </div>

            <div className="control_group w_100">
              <label htmlFor="features">Features</label>
              <TextField
                id="features"
                variant="standard"
                placeholder="Enter Features"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      onClick={handleAddChip}
                      position="end"
                      className="size_big circle"
                    >
                      <AddIcon />
                    </InputAdornment>
                  ),
                }}
              />
              {chips.length > 0 && (
                <ul className="chips_wrap">
                  {chips.map((chip, index) => (
                    <li key={index}>
                      {chip}
                      <button
                        type="button"
                        className="chip_delete_btn"
                        onClick={() => handleDelete(chip)}
                      >
                        <CloseIcon fontSize="small" />
                      </button>
                    </li>
                  ))}
                </ul>
              )}

            </div>
          </div>

          <div className="form_btn">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSubscription;
